module.exports = __webpack_public_path__ + "img/AusDemNichts.3885ab8d.jpg";